export const SITE_FEATURE_AVAILABILITY_RULES = {
    demandCharge: [
        {
            section: "Optimization Features",
            option: "Demand Charge Optimization",
        },
        {
            section: "Optimization Features",
            option: "Demand on Charge"
        },
    ],
    tariffManagement: [
        {
            section: "Optimization Features",
            option: "Time of Use (Electricity Tariff based Optimization)",
        },
        {
            section: "Optimization Features",
            option: "Time of Use Tariff optimization",
        },
    ],
    selfConsumption: [
        { section: "Optimization Features", option: "Self Consumption" },
    ],
    exportOptimization: [
        {
            section: "Optimization Features",
            option: "Limit Energy Import/Export",
        },
        {
            section: "Optimization Features",
            option: "Export predictive optimization",
        },
        { section: "PMS features", option: "Import/export management" },
    ],
    exportManagement: [
        { section: "Optimization Features", option: "Export management" },
    ],
    islandingPreparation: [
        {
            section: "Optimization Features",
            option: "Islanding preparation",
        },
    ],
    constraintsBasedOptimization: [
        {
            section: "Optimization Features",
            option: "Constraints based optimization",
        },
    ],
    stormPreparedness: [
        {
            section: "Optimization Features",
            option: "Outage mode preparation",
        },
    ],
    greenConsumption: [
        { section: "Optimization Features", option: "Green Consumption" },
    ],
    manualDemandResponse: [
        {
            section: "Flexibility Services",
            option: "Manual Demand Response",
        },
    ],
    electricalVehicleEnergyManagement: [
        {
            section: "Flexibility Services",
            option: "Electrical Vehicle Energy Management",
        },
    ],
    offGridMode: [{ section: "Resilience", option: "off Grid Mode" }],
    noExport: [
        {
            section: "Real Time Control",
            option: "Real Time Export Control (EMO Controller based)",
        },
    ],
    bessEnergyExchanges: [
        {
            section: "Real Time Control",
            option: "Controlled BESS Energy Exchanges with the grid",
        },
    ],
    antiIslandingDetection: [
        { section: "Compliance", option: "antiIslandingDetection" },
        { section: "PMS features", option: "Anti islanding detection" },
    ],
    energyOptimaztion: [
        { section: "Ems capabilities", option: "Energy optimization" },
    ],
    staticTariffBased: [
        { section: "Energy optimization", option: "Static Tariff Based" },
    ],
    dynamicTariffBased: [
        { section: "Energy optimization", option: "Dynamic Tariff Based" },
    ],
    bessOperatingModes: [
        { section: "PMS features", option: "BESS operating modes" },
    ],
    loadManagement: [
        { section: "PMS features", option: "Load management" },
    ],
    remoteMonitoringControl: [
        {
            section: "Ems capabilities",
            option: "Remote energy monitoring",
        },
    ],
};
